import api from 'api';

export default async ({ courseSlug }) => {
  try {
    if (!window.location.hash) return null;

    const hashContent = window.location.hash.slice(1);

    const response = await api.get(
      `/reader/courses/${courseSlug}/reader-links?hash=${hashContent}`
    );

    if (!response.data || !response.data.success || !response.data.links.length) {
      return null;
    }

    const { content, start, end, BlockId } = response.data.links[0];
    return {content, start, end, blockId: BlockId};
  } catch (err) {
    return null;
  }
};
